import { ISendRetenoAnalyticsRequest } from 'api/components/Analytics/types';

import * as actionTypes from './actionTypes';

export const sendRetenoAnalyticsRequest = (payload: ISendRetenoAnalyticsRequest) => {
    return {
        type: actionTypes.SEND_RETENO_ANALYTICS_REQUEST,
        payload,
    } as const;
};
